import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/commons/contexts/auth/guard';
// components
import { LoadingScreen } from 'src/commons/components/loading-screen';
import WrapperLayout from 'src/commons/layouts/wrapper/layout';
// path
import { paths } from '../paths';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/features/charge-your-palta'));

// ----------------------------------------------------------------------

export const chargeYourPaltaRoutes = [
  {
    path: '/charge-your-palta',
    element: (
      <AuthGuard>
        <WrapperLayout title="Carga tu Palta" path={paths.home.root}>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </WrapperLayout>
      </AuthGuard>
    ),
    children: [{ element: <IndexPage />, index: true }],
  },
];
